// client/src/pages/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{ padding: '1rem' }}>
      <h1>404 — Page Not Found</h1>
      <p>
        <Link to="/">Go back home</Link>
      </p>
    </div>
  );
}
